export const localStorageGetItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (ex) {
    if (ex instanceof Error) {
      console.warn(ex.message);
    } else {
      console.warn('Unknown error occurred in localStorageGetItem');
    }
  }
  return null;
};

export const localStorageSetItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (ex) {
    if (ex instanceof Error) {
      console.warn(ex.message);
    } else {
      console.warn('Unknown error occurred in localStorageSetItem');
    }
  }
};

export const localStorageRemoveItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (ex) {
    if (ex instanceof Error) {
      console.warn(ex.message);
    } else {
      console.warn('Unknown error occurred in localStorageRemoveItem');
    }
  }
};